import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { X } from 'react-feather';
import '../../Styles/Annotator/AdvicesComponent.css';
import '../../Styles/Annotator/EditAdviceComponent.css';
import IgnoreListViewComponent from './IgnoreListVIewComponent';
import IgnoreListComponent from './IgnoreListComponent';

function IgnoreListModalComponent() {
    const [showIgnoreListModal, setShowIgnoreListModal] = useState(false);

    function onClose() {
        setShowIgnoreListModal(false);
    }

    return (
        <>
            <Button onClick={() => setShowIgnoreListModal(true)} className="handwai-btn-create">
                {' '}
                Ignore Item
            </Button>

            <Modal
                show={showIgnoreListModal}
                onHide={() => onClose()}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Ignore List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <IgnoreListComponent /> <br /> <br />
                    <IgnoreListViewComponent />
                    <Modal.Footer>
                        <Button size="lg" className="btn-lg" variant="outline-dark" onClick={() => onClose()}>
                            <X />
                            Abbrechen
                        </Button>
                    </Modal.Footer>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default IgnoreListModalComponent;
